module.exports = __webpack_public_path__ + "media/src/Shared/Assets/rvezy_logo-46c1f9a292a41e57a0034456f75956789ceebcaf645517ec0fe45ae723387a0b.svg";